export enum statusesEnum {
  INACT = 'INACT',
}
